import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Client.vue'

Vue.use(Router)

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/client'
        },
        {
            path: '/client',
            name: 'client',
            component: Home
        },
        {
            path: '/site_config',
            name: 'siteConfig',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/SiteConfig.vue')
        },
        {
            path: '/pay_meal',
            name: 'payMeal',
            component: () => import('./views/PayMeal.vue')
        },
        {
            path: '/build_site',
            name: 'buildSite',
            component: () => import('./views/BuildSite.vue')
        }
    ]
})
